export default __webpack_public_path__ + "static/media/lyftLogoWhite.3edff147.svg";